import type { Step } from "react-joyride";

export const contractExpiryTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າການຕໍ່ອາຍຸ & ຕິດຕາມສັນຍາ! ຫນ້ານີ້ຈະສະແດງສັນຍາທີ່ໃກ້ຫມົດອາຍຸ ແລະ ຈັດການການຕໍ່ອາຍຸ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="expiry-summary-cards"]',
    content:
      "ນີ້ແມ່ນບັດສະຫຼຸບ. ທ່ານຈະເຫັນຈຳນວນສັນຍາທີ່ສຳຄັນ (30 ວັນ), ຈະມາເຖິງ (60 ວັນ), ປົກກະຕິ (90 ວັນ), ແລະເກັບຮັກສາ (ຫມົດອາຍຸ). ບັດແຕ່ລະບັດຈະສະແດງຈຳນວນສັນຍາໃນແຕ່ລະໝວດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="expiry-critical-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສັນຍາທີ່ສຳຄັນ (ຈະຫມົດອາຍຸໃນ 30 ວັນ). ສັນຍາເຫຼົ່ານີ້ຕ້ອງການການເອົາໃຈໃສ່ທັນທີ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ ຫຼື ຕໍ່ອາຍຸສັນຍາໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="expiry-upcoming-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສັນຍາທີ່ຈະມາເຖິງ (60 ວັນ). ສັນຍາເຫຼົ່ານີ້ຈະຫມົດອາຍຸໃນອີກ 31-60 ວັນ. ທ່ານຄວນເລີ່ມກະກຽມການຕໍ່ອາຍຸຫຼືການຈັດການອື່ນໆ.",
    placement: "top",
  },
  {
    target: '[data-tourid="expiry-routine-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສັນຍາປົກກະຕິ (90 ວັນ). ສັນຍາເຫຼົ່ານີ້ຈະຫມົດອາຍຸໃນອີກ 61-90 ວັນ. ທ່ານຍັງມີເວລາພຽງພໍໃນການກະກຽມ.",
    placement: "top",
  },
  {
    target: '[data-tourid="expiry-archived-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສັນຍາທີ່ເກັບຮັກສາ (ຫມົດອາຍຸແລ້ວ). ສັນຍາເຫຼົ່ານີ້ແມ່ນສັນຍາທີ່ຫມົດອາຍຸແລ້ວ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດຫຼືຈັດການສັນຍາເຫຼົ່ານີ້.",
    placement: "top",
  },
];
